module.exports = __webpack_public_path__ + "img/1.d0687f64.svg";